import React, { memo, useRef, useEffect, useState } from 'react';
import styles from './EquityTag.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useCallback } from 'react';
import Swiper from 'react-id-swiper';
import { updateShowWpOrder } from '../../../actions/wallpaper';
import { getVipState, setEquityVip } from '../../../actions/wallpaperPay';
import 'swiper/css/swiper.css';
import Dialog from '../../../components/Dialog/Dialog';
import config from '../config';
import Toast from '../../../components/Toast/Toast';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import { handleLogin } from '../../../utils/hooks/useLoginStatus';
import { useActivate, useUnactivate } from 'react-activation';

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

const SelectSetVip = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.isUpdateVip,
);

export default memo(() => {
  const dispatch = useDispatch();
  const vipState = useSelector(SelectVipState);
  const swiperEl = useRef(null);
  const [showSwiper, setShowSwiper] = useState(false);
  const [wpDialog, setWpDialog] = useState(false);
  const [control, setControl] = useState(false);
  const loginStatus = useLoginStatus();
  const setVipTag = useSelector(SelectSetVip);

  const titleList = ['全库壁纸随意用', '付费壁纸随意下', '享壁纸轮播列表无上限'];
  const tagParams = {
    direction: 'vertical',
    spaceBetween: 20,
    allowTouchMove: false,
    speed: 800,
    loop: true,
    autoplay: {
      delay: 2500,
    },
  };

  useActivate(() => {
    dispatch(getVipState());

    // 处理切换回来 不滚动的问题
    setShowSwiper(false);
    setTimeout(() => {
      setShowSwiper(true);
    }, 25);
  });

  useEffect(() => {
    setTimeout(() => {
      setShowSwiper(true);
    }, 50);
  }, []);

  useEffect(() => {
    if (!loginStatus) {
      dispatch(setEquityVip());
    } else {
      dispatch(getVipState());
    }
  }, [loginStatus]);

  useEffect(() => {
    dispatch(getVipState());
  }, [setVipTag]);

  const judgeState = useCallback(() => {
    if (
      vipState.vipFixTimeChargeState === 1 ||
      (vipState.vipFixTimeChargeState === 0 && vipState.vipState === 1)
    ) {
      if (vipState.vipState === 0) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }, [vipState]);

  const callbackOrder = useCallback(
    flag => {
      if (flag) {
        dispatch(getVipState());
      }
    },
    [vipState],
  );

  const handleOpenVip = () => {
    if (!loginStatus) {
      handleLogin();
    } else {
      dispatch(
        updateShowWpOrder({
          show: true,
          wallpaperId: '',
          code: '',
          wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
          scenetype: 'resident', // 'set', 'dl', 'resident','resident_category', 'loop_single', 'loop_batch', 'loop_start'
          callbackTurnOrder: callbackOrder,
        }),
      );
    }
  };

  const handleCloseDialog = () => {
    setWpDialog(false);
  };

  const handleUnsubscribe = async () => {
    let res = await config.unsubscribe();
    if (res?.status === 0) {
      Toast.success({
        content: '提交成功',
      });
      dispatch(getVipState());
    } else {
      Toast.error({
        content: '提交失败',
      });
    }
    handleCloseDialog();
  };

  return (
    <div className={`${styles.vip} ${judgeState() ? styles.equity : styles.no_equity}`}>
      <div className={styles.vip_left}>
        <div className={styles.title}>
          {vipState.vipState === 0 && <div>Hi，您尚未开通壁纸订阅</div>}
          {vipState.vipState === 1 && <div>Hi，您已开通壁纸订阅权益</div>}
          {vipState.vipState === 2 && <div>Hi，您的壁纸权益即将到期</div>}
        </div>
        <div className={styles.wp_describe}>
          {vipState && vipState?.vipState === 0 && titleList?.length > 0 && showSwiper && (
            <Swiper {...tagParams} ref={swiperEl} id="wp_swiper">
              {titleList?.map((item, i) => (
                <div key={i} className={styles.swiper_item}>
                  {item}
                </div>
              ))}
            </Swiper>
          )}
          {vipState.vipState !== 0 && (
            <>
              <span>{vipState.vipExpireTime}到期</span>
              {vipState.vipFixTimeChargeState === 0 && vipState.vipState === 1 && (
                <span className={styles.btn} onClick={handleOpenVip}>
                  去续费
                  <i className="iconfont icon-point_right" />
                </span>
              )}
              {vipState.vipFixTimeChargeState === 1 && [1, 2].includes(vipState.vipState) && (
                <div className={styles.close_vip}>
                  ，到期自动续费{' '}
                  <div className={styles.close_btn} onClick={() => setControl(!control)}>
                    ...
                    {control && (
                      <div className={styles.btn_describe} onClick={() => setWpDialog(true)}>
                        管理连续订阅
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {!judgeState() && (
        <div className={styles.vip_right_btn} onClick={handleOpenVip}>
          <div className={styles.vip_tag} />
          {vipState.vipState === 0 && <div className={styles.vip_btn_text}>去开通</div>}
          {vipState.vipFixTimeChargeState === 0 && vipState.vipState === 2 && (
            <div className={styles.vip_btn_text}>去续期</div>
          )}
        </div>
      )}
      {wpDialog && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleCloseDialog}
          title="温馨提示"
        >
          <div className={styles.wp_dialog_describe}>
            取消连续订阅后，订阅到期后您将无法继续享受特权。
          </div>
          <div className={styles.wp_dialog_btn}>
            <div className={styles.wp_dialog_submit} onClick={handleUnsubscribe}>
              确认取消
            </div>
            <div className={styles.wp_dialog_keep} onClick={handleCloseDialog}>
              保持订阅
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
});
